<template>
    <div class="fullHeight">
        <div class="mypage_mainwindow">
            <div class="pageTitles">
                <div>{{ page_title }}</div>
                <!-- <button @click="openHelpPage" class="btn btn-outline-info help-btn">ヘルプ</button> -->
            </div>
            <div class="cardwindow">
                <div class="row ml-2">
                    <h5 class="col font-weight-bold">{{ fullName }}&nbsp;&nbsp;様</h5>
                </div>
                <div class="graywindow">
                    <div class="col-sm-12">
                        <p class="content text-center pt-4">{{ text }}</p>
                    </div>
                    <div class="row justify-content-center pb-2">
                        <button class="btn nextBtn col-sm-3 mx-5 my-2" v-on:click="run_mailto()" :hidden="tmpMemberNo == 0">仮登録</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_TMP_MEMBER_INFO } from '../../constants/mypage_mail_setting';

export default {
    components: {
    },
    data () {
        return {
            page_title: '登録メール送信',
            golf_group_code: process.env.MIX_GROUP_CODE,
            fullName: '',
            tmpMemberNo: 0,
            text: '',
            address: process.env.MIX_BLANK_MAIL_ADRESS,
            subject: '',
            body: ''
        };
    },
    created () {
        this.$store.commit("loading/setIsLoading", true);
        this.initialize();
        this.$store.commit("loading/setIsLoading", false);
    },
    methods: {
        async initialize () {
            await this.getTmpMemberInfo();
        },
        /** ----------------------------------------------
         * メーラー起動
         * ---------------------------------------------- */
        run_mailto () {
            // address = '~@co.jp';
            // subject = '件名';
            // body = '本文' + hiddenData;
            window.location.href = 'mailto:' + this.address + '?subject=' + this.subject + '&body=TMNSTART' + this.$route.query.id + 'ENDTMN';
        },
        /** ----------------------------------------------
         * 予約情報を取得
         * ---------------------------------------------- */
       async getTmpMemberInfo () {
            this.$apollo.query({
                query: GET_TMP_MEMBER_INFO,
                variables: {
                  tmp_member_no: this.$route.query.id
                }
            }).then(res => {
                this.tmpMemberNo = res.data.GetTmpMemberInfo.tmp_member_no;
                if (this.tmpMemberNo !== 0) {
                    this.fullName = res.data.GetTmpMemberInfo.full_name;
                    this.text = '「仮登録」をタップするとメーラーが起動します。件名、本文を変更せずそのまま送信してください。本登録メールが届きますのでメール内のURLをタップして本登録を行ってください。';
                }
            }).catch(error => {
                this.fullName = 'ゲスト様';
                this.text = '有効なURLではありません。';
            })
        },
        openHelpPage() {
            window.open('/help', '_blank');
        }
    }
}
</script>

<style scoped>
</style>
